import type { Components, Theme } from '@mui/material/styles';

export const linearProgressTheme: Components<Theme>['MuiLinearProgress'] = {
  styleOverrides: {
    root: {
      width: '100%'
    }
  }
};
